export default __webpack_public_path__ + "static/media/logo-season-print.5e548550.png";